import styled from 'styled-components';

export const Container = styled.div`
  border: 2px solid ${({ theme }) => theme.colors.text200};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  overflow: hidden;
  margin-bottom: 1rem;
`;

export const Header = styled.div`
  padding: 0.3rem 1rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid ${({ theme }) => theme.colors.text200};
  margin-bottom: -2px;
`;

export const Body = styled.div`
  padding: 0.5rem 1rem;
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  overflow-x: auto;
`;
